import React, { useEffect, useState } from 'react'
import { Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { history } from './_state/helpers'
import PublicLayout from './Layouts/PublicLayout'
import privateRoutes from 'routes/privateRoutes'
import publicRoutes from 'routes/publicRoutes'
import studentPrivateRoutes from 'routes/studentPrivateRoutes'
import PrivateRoute from 'routes/PrivateRoute'
import { IntlProvider } from 'react-intl'
import tinycolor from 'tinycolor2'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'
import Notifier from './Components/Notifier'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { snackbarActions } from './_state/actions/snackbar.actions'
import { makeStyles } from '@material-ui/core'
import localeNorData from 'messages/l10n/nb.json'
import localeEnData from 'messages/l10n/en.json'
import localeDeData from 'messages/l10n/de.json'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import 'assets/react_dates_overrides.css'
import 'react-datasheet/lib/react-datasheet.css'
import { CapeeshColors } from './assets/ColorPalette'
import GlobalLessonPreview from './Components/AppWebGL/GlobalLessonPreview/GlobalLessonPreview'
import StudentPrivateRoute from './routes/StudentPrivateRoute'

import { v4 as uuidv4 } from 'uuid'
import NotFound from './Views/Public/NotFound'
import { CapeeshLanguage } from './Logic/CapeeshConstants'

const getCurrentTheme = (organization) => {
    const pathName = window.location.pathname

    let primaryColor = CapeeshColors.Primary600
    // if (pathName === "/" || pathName == '') {
    //     primaryColor = CapeeshColors.OffWhite;
    // }
    // else
    if (pathName.startsWith('/creator')) {
        primaryColor = CapeeshColors.Purple
    } else if (pathName.startsWith('/admin')) {
        primaryColor = CapeeshColors.Blue
    } else if (pathName.startsWith('/student')) {
        primaryColor = CapeeshColors.Primary900
    }

    let secondaryColor = tinycolor(primaryColor).complement().toHexString()
    // let primaryColor = '#FF5159';
    let lightTextColor = '#FFFFFF'
    let darkTextColor = '#232B35'
    // let secondaryColor = "#2278CF";
    let primaryTextColor = lightTextColor
    let secondaryTextColor = lightTextColor

    // if (organization.myOrganizations && organization.selectedOrganization) {
    //     const currentOrganization = organization.myOrganizations.find(x => x.id === organization.selectedOrganization);
    //     primaryColor = currentOrganization?.themePrimaryColor ? currentOrganization.themePrimaryColor : primaryColor;
    //     secondaryColor = tinycolor(primaryColor).complement().toHexString();
    // }

    const primaryTextColorReadability = tinycolor.readability(primaryColor, primaryTextColor)
    // if(primaryTextColorReadability < 3.05)
    //     primaryTextColor = darkTextColor;
    // const secondaryTextColorReadability = tinycolor.readability(secondaryColor, secondaryTextColor);
    // if(secondaryTextColorReadability < 3.05)
    //     secondaryTextColor = darkTextColor;

    return createMuiTheme({
        palette: {
            primary: {
                main: primaryColor,
                contrastText: primaryTextColor,
            },
            background: {
                default: CapeeshColors.OffWhite,
            },
        },
        typography: {
            useNextVariants: true,
            fontFamily: [
                'Lato',
                'Rubik',
                'Roboto',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
        overrides: {
            MuiTypography: {
                colorTextPrimary: CapeeshColors.DarkText,
                root: {
                    color: CapeeshColors.DarkText,
                },
            },
            MuiButton: {
                contained: {
                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.12)',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    '&:hover': {
                        boxShadow: '0px 8px 5px rgba(0, 0, 0, 0.2)',
                    },
                    '&:disabled': {
                        opacity: 0.5,
                    },
                },
                outlined: {
                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.12)',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    '&:hover': {
                        boxShadow: '0px 8px 5px rgba(0, 0, 0, 0.2)',
                    },
                    '&:disabled': {
                        opacity: 0.5,
                    },
                },
            },
            MuiListSubheader: {
                root: {
                    paddingLeft: '16px !important',
                },
            },
            MuiMenuItem: {
                root: {
                    fontSize: '14px',
                    transition: 'all 150ms linear',
                    '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                        color: primaryTextColor,
                    },
                },
                // selected: {
                //     backgroundColor: `${primaryColor} !important`,
                //     color: primaryTextColor
                // },
            },
            MuiCard: {
                root: {
                    background: '#FFFFFF',
                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.12)',
                    borderRadius: '10px',
                },
            },
            MuiCardHeader: {
                root: {
                    background: '#FFFFFF00',
                    alignItems: 'normal',
                    maxHeight: '52px',
                },
                title: {
                    fontFamily: 'Rubik',
                    fontWeight: 'medium',
                    fontSize: '24px',
                    lineHeight: '22px',
                    color: '#35323C',
                    height: '30px',
                    margin: '10px 0px 5px 0px',
                },
                subheader: {
                    lineHeight: '22px',
                    fontSize: '18px',
                    color: '#8E8E93',
                },
            },
            MuiCardContent: {
                root: {
                    //background: '#FFFBF2',
                    background: 'white',

                    borderRadius: '5px',
                },
            },
            MuiCardActions: {
                root: {
                    borderTop: 'solid 1px #eee',
                    background: 'white',
                    //background: '#FFFBF2',
                    justifyContent: 'space-between',
                },
            },
            MuiPaper: {
                elevation2: {
                    boxShadow: 'none',
                },
            },
            MuiTabs: {
                root: {
                    borderBottom: '1px solid #e8e8e8',
                },
                indicator: {
                    backgroundColor: primaryColor,
                    height: '3px',
                },
            },
            MuiTab: {
                root: {
                    textTransform: 'initial',
                    transition: 'all 250ms linear',
                    '&:hover': {
                        color: primaryColor,
                        opacity: 1,
                    },
                    '&$selected': {
                        color: primaryColor,
                        fontStyle: 'bold',
                    },
                    '&:focus': {
                        color: primaryColor,
                        fontStyle: 'bold',
                    },
                },
            },
            MuiStepper: {
                root: {
                    backgroundColor: '#ffffff00',
                    iconColor: primaryColor,
                },
            },
            MuiTableHead: {
                root: {
                    background: primaryColor,
                },
            },
            MuiTableSortLabel: {
                root: {
                    color: '#FFFFFF !important',
                },
                icon: {
                    color: '#FFFFFF !important',
                },
            },
            MuiCheckbox: {
                root: {
                    color: 'inherit !important',
                },
            },
            MTableToolbar: {
                root: {
                    backgroundColor: `${primaryColor} !important`,
                    color: primaryTextColor,
                },
            },
            MuiTableCell: {
                root: {
                    padding: '10px !important',
                },
                head: {
                    backgroundColor: 'inherit !important',
                    color: `${primaryTextColor} !important`,
                },
            },
            MuiChip: {
                root: {
                    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.12)',
                    borderRadius: '8px',
                    backgroundColor: '#FFFFFF',
                    fontWeight: 'bold',
                },
                deleteIcon: {
                    fill: primaryColor,
                    color: primaryTextColor,
                    '&:hover': {
                        fill: tinycolor(primaryColor).darken(10),
                    },
                },
            },
            MuiExpansionPanel: {
                root: {
                    boxShadow: 'none',
                    borderRadius: '10px !important',
                    backgroundColor: '#EFEFF4',
                },
            },
            MuiExpansionPanelSummary: {
                root: {
                    height: '65px',
                    borderRadius: '10px',
                    backgroundColor: primaryColor,
                    color: primaryTextColor,
                },
                expandIcon: {
                    color: primaryTextColor,
                },
                content: {
                    color: primaryTextColor,
                },
            },
        },
    })
}

const useStyles = makeStyles((theme) => ({
    success: {
        backgroundColor: '#4caf50',
    },
    error: {
        backgroundColor: '#f44336',
    },
    info: {
        backgroundColor: '#2196f3',
    },
    warning: {
        backgroundColor: '#ff9800',
    },
    closeButton: {
        color: '#FFFFFF',
    },
}))

const App = (props) => {
    const { snackbar, dispatch, organization, user } = props
    const snackbarRef = React.createRef()
    const classes = useStyles()

    const [languageWithoutRegionCode, setLanguageWithoutRegionCode] = useState('en')
    const [messages, setMessages] = useState(localeEnData)
    const [showLessonPreview, setShowLessonPreview] = useState(false)

    const [previousOffline, setpreviousOffline] = useState(false)

    let deviceGuid = JSON.parse(localStorage.getItem('deviceGuid'))
    if (!deviceGuid) {
        const deviceGuid = uuidv4()
        localStorage.setItem('deviceGuid', JSON.stringify({ deviceGuid: deviceGuid }))
    }

    const pathName = window.location.pathname

    const isDevStudentDomain = window.location.origin.includes('devstudent.capeesh.com')
    const isProdStudentDomain = window.location.origin.includes('student.capeesh.com')

    const isStudentDomain = isDevStudentDomain || isProdStudentDomain

    let isStudent = false
    if (pathName.startsWith('/student')) {
        isStudent = true
    }
    let isLogin = false
    if (pathName.startsWith('/login')) {
        isLogin = true
    } else if (pathName.startsWith('/forgot')) {
        isLogin = true
    }
    const onClickDismiss = (key) => () => {
        snackbarRef.current.closeSnackbar(key)
    }

    const checkAndSetLocalizedLanguages = () => {
        if (props.user?.userDashboardLanguageId === 1 && languageWithoutRegionCode !== 'en') {
            setLanguageWithoutRegionCode('en')
            setMessages(localeEnData)
        }

        if (props.user?.userDashboardLanguageId === 3 && languageWithoutRegionCode !== 'nb') {
            setLanguageWithoutRegionCode('nb')
            setMessages(localeNorData)
        }

        if (props.user?.userDashboardLanguageId === 6 && languageWithoutRegionCode !== 'de') {
            setLanguageWithoutRegionCode('de')
            setMessages(localeDeData)
        }
    }

    async function loadLocaleData(language) {
        switch (language.id) {
            case CapeeshLanguage.EnglishUK:
                return await import('messages/l10n/student/en.json')
            case CapeeshLanguage.EnglishUS:
                return await import('messages/l10n/student/en.json')
            case CapeeshLanguage.Norwegian:
                return await import('messages/l10n/student/nb.json')
            case CapeeshLanguage.Spanish:
                return await import('messages/l10n/student/es.json')
            case CapeeshLanguage.Nynorsk:
                return await import('messages/l10n/student/nn.json')
            case CapeeshLanguage.Dutch:
                return await import('messages/l10n/student/nl.json')
            case CapeeshLanguage.German:
                return await import('messages/l10n/student/de.json')
            case CapeeshLanguage.KurdishKurmanji:
                return await import('messages/l10n/student/ku-KU.json')
            case CapeeshLanguage.Somali:
                return await import('messages/l10n/student/so.json')
            case CapeeshLanguage.Persian:
                return await import('messages/l10n/student/fa.json')
            case CapeeshLanguage.Tamil:
                return await import('messages/l10n/student/ta.json')
            case CapeeshLanguage.Thai:
                return await import('messages/l10n/student/th-TH.json')
            case CapeeshLanguage.Turkish:
                return await import('messages/l10n/student/tr.json')
            case CapeeshLanguage.Urdu:
                return await import('messages/l10n/student/ur.json')
            case CapeeshLanguage.Vietnamese:
                return await import('messages/l10n/student/vi-VI.json')
            case CapeeshLanguage.Pashto:
                return await import('messages/l10n/student/ps.json')
            case CapeeshLanguage.Lithuanian:
                return await import('messages/l10n/student/lt.json')
            case CapeeshLanguage.Italian:
                return await import('messages/l10n/student/it-IT.json')
            case CapeeshLanguage.Arabic:
                return await import('messages/l10n/student/ar.json')
            case CapeeshLanguage.Amharic:
                return await import('messages/l10n/student/am.json')
            case CapeeshLanguage.Romanian:
                return await import('messages/l10n/student/ro.json')
            case CapeeshLanguage.ChineseSimplified:
                return await import('messages/l10n/student/zh-CH.json')
            case CapeeshLanguage.Greek:
                return await import('messages/l10n/student/el.json')
            case CapeeshLanguage.Ukrainian:
                return await import('messages/l10n/student/uk.json')
            case CapeeshLanguage.Tigrinya:
                return await import('messages/l10n/student/ti.json')
            case CapeeshLanguage.Dari:
                return await import('messages/l10n/student/fa-AF.json')
            case CapeeshLanguage.Nepali:
                return await import('messages/l10n/student/ne.json')
            case CapeeshLanguage.KurdishSorani:
                return await import('messages/l10n/student/ku-SO.json')
            case CapeeshLanguage.PortugueseBrazil:
                return await import('messages/l10n/student/pt-BR.json')
            case CapeeshLanguage.Latvian:
                return await import('messages/l10n/student/lv.json')
            case CapeeshLanguage.Albanian:
                return await import('messages/l10n/student/sq.json')
            case CapeeshLanguage.Russian:
                return await import('messages/l10n/student/ru.json')
            case CapeeshLanguage.French:
                return await import('messages/l10n/student/fr-FR.json')
            case CapeeshLanguage.Polish:
                return await import('messages/l10n/student/pl.json')
            case CapeeshLanguage.SpanishLA:
                return await import('messages/l10n/student/es.json')

            default:
                return []
        }
    }

    const checkAndSetLocalizationLanguageStudent = () => {
        const dashLangId = Number(props.student.userDashboardLanguageId)
        if (!dashLangId || !props.student.languages?.length) {
            return
        }
        const language = props.student.languages.find((x) => Number(x.id) === dashLangId)
        if (!language) {
            return
        }
        loadLocaleData(language)
            .then((loaded) => {
                const msgs = loaded?.default || loaded
                if (msgs && typeof msgs === 'object') {
                    setMessages(msgs)
                    setLanguageWithoutRegionCode(language.languageTag || language.cultureCode || 'en')
                }
            })
            .catch((err) => {
                console.warn('[i18n] Failed to load student locale for language', language.id, err)
            })
    }

    useEffect(() => {
        checkAndSetLocalizedLanguages()
    }, [props.user.userDashboardLanguageId])

    useEffect(() => {
        checkAndSetLocalizationLanguageStudent()
    }, [props.student.userDashboardLanguageId, props.student.languages])

    useEffect(() => {
        props.clearSnackbar()

        if (props.user?.userDashboardLanguageId) {
            checkAndSetLocalizedLanguages()
        } else {
            let language =
                (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage

            let browserlanguageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0]
            if (browserlanguageWithoutRegionCode === 'de') {
                setLanguageWithoutRegionCode('de')
                setMessages(localeDeData)
            } else if (browserlanguageWithoutRegionCode === 'no' || browserlanguageWithoutRegionCode === 'nb') {
                setLanguageWithoutRegionCode('de')
                setMessages(localeDeData)
            }
        }
    }, [])

    useEffect(() => {
        document.addEventListener('unityLessonPreviewHideShowToggle', () => {
            setShowLessonPreview(!showLessonPreview)
        })
    }, [])

    const handleOnChange = (event) => {
        if (!event) {
            setpreviousOffline(true)
        }
        if (event && previousOffline) {
            // to get a new instance of the preview to make sure it works, reload the page when coming back from offline
            window.location.reload()
        }
    }

    return (
        <IntlProvider locale={languageWithoutRegionCode} messages={messages} textComponent="span">
            <MuiThemeProvider theme={getCurrentTheme(organization)}>
                <SnackbarProvider
                    ref={snackbarRef}
                    action={(key) => (
                        <IconButton onClick={onClickDismiss(key)} className={classes.closeButton}>
                            <CloseIcon />
                        </IconButton>
                    )}
                    classes={{
                        variantSuccess: classes.success,
                        variantError: classes.error,
                        variantWarning: classes.warning,
                        variantInfo: classes.info,
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}>
                    <Notifier />
                    {/*<Online onChange={handleOnChange}>*/}
                    <ConnectedRouter history={history}>
                        {!isStudent && !isLogin && (
                            <GlobalLessonPreview
                                isOpen={showLessonPreview}
                                closeDialog={() => setShowLessonPreview(false)}
                            />
                        )}

                        <Switch>
                            {!isStudentDomain &&
                                privateRoutes.map((route, key) => {
                                    return (
                                        <PrivateRoute
                                            exact
                                            path={route.path}
                                            component={route.component}
                                            render={(props) => route.component(...props)}
                                            key={key}
                                            title={'Capeesh - ' + route.id}
                                        />
                                    )
                                })}
                            {studentPrivateRoutes.map((route, key) => {
                                return (
                                    <StudentPrivateRoute
                                        exact
                                        path={route.path}
                                        component={route.component}
                                        render={(props) => route.component(...props)}
                                        key={key}
                                        title={'Capeesh - ' + route.id}
                                    />
                                )
                            })}
                            {publicRoutes.map((route, key) => {
                                return (
                                    <PublicLayout
                                        exact
                                        path={route.path}
                                        component={route.component}
                                        render={(props) => route.component(...props)}
                                        key={key}
                                        title={'Capeesh - ' + route.id}
                                    />
                                )
                            })}
                            <NotFound />
                        </Switch>
                    </ConnectedRouter>
                    {/*</Online>*/}
                    {/*<Offline>*/}
                    {/*    <FormattedMessage*/}
                    {/*        id="globalwords"*/}
                    {/*        defaultMessage="Your computer is not currently connected to the internet."*/}
                    {/*    />*/}
                    {/*</Offline>*/}
                </SnackbarProvider>
            </MuiThemeProvider>
        </IntlProvider>
    )
}

App.propTypes = {}

const mapStateToProps = (state) => {
    const { alert, snackbar, organization, user, student } = state
    return {
        alert,
        snackbar,
        organization,
        user,
        student,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearSnackbar: () => dispatch(snackbarActions.clearSnackbar()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
